var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSkontoProductIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1833_15427)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5843 20.3987C52.9871 20.7073 52.9871 21.37 52.5843 21.6786L35.9267 34.4393C35.4642 34.7936 34.8349 34.4247 34.8349 33.7994L34.835 28.0014H28.6763C27.9859 28.0014 27.4263 27.4418 27.4263 26.7514V26.2006C27.4263 25.2373 26.929 24.3658 26.127 23.8956C25.301 23.4115 24.1976 23.3994 23.3193 24.0722L18.7738 27.5543C18.403 27.8384 17.9116 28.0157 17.515 27.7692C17.0758 27.4961 16.7834 27.0093 16.7834 26.4541V15.6232C16.7834 14.7686 17.4762 14.0759 18.3307 14.0759H34.835L34.8349 8.27789C34.8349 7.65262 35.4642 7.28374 35.9267 7.63798L52.5843 20.3987Z",
    fill: "#009DD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9601 33.2487C32.9601 32.5583 32.4005 31.9987 31.7101 31.9987H25.5515V26.2006C25.5515 25.5754 24.9222 25.2064 24.4598 25.5607L7.80212 38.3214C7.39929 38.63 7.39929 39.2927 7.80212 39.6013L24.4598 52.3621C24.9222 52.7164 25.5515 52.3475 25.5515 51.7222V45.9241H42.0558C42.9104 45.9241 43.6031 45.2314 43.6031 44.3769V33.5459C43.6031 32.9907 43.3107 32.5037 42.8714 32.2308C42.4748 31.9843 41.9834 32.1617 41.6127 32.4456L37.0671 35.9279C36.1888 36.6006 35.0854 36.5885 34.2594 36.1043C33.4574 35.6343 32.9601 34.7626 32.9601 33.7995V33.2487Z",
    fill: "url(#paint0_linear_1833_15427)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1833_15427",
    x: 5.5,
    y: 6.5,
    width: 49.3865,
    height: 49.0001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_15427"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_15427",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1833_15427",
    x1: 24.9713,
    y1: 25.4227,
    x2: 24.649,
    y2: 52.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#009DD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#3E4CB4"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSkontoProductIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/skonto-product-icon.098094f4.svg";
export { ForwardRef as ReactComponent };